import React from 'react';
import Sidebar from '../sidebar';
import Typography from '../Typography';
import Logo from '../Logo';
import Spacing from '../spacing';
import Color from '../Color';
import Icons from '../Icons';
import styles from './style-guide.module.scss';

class StyleGuide extends React.Component {
  render() {
    return (
      <section className={styles.aptitudeBody}>
        <Sidebar />
        <div className={styles.aptitudeBodyContent}>
          <Color />
          <Logo />
          <Icons />
          <Spacing />
          <Typography />
        </div>
      </section>
    );
  }
}

export default StyleGuide;
